export default function calledorganizationmaterials(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                calledorganizationmaterial: action.calledorganizationmaterial,
            }
        default:
            return state;
    }
}
